import * as yup from 'yup';
import { REQUIRED_MESSAGE } from 'utils/validations';

const schema = yup.object().shape({
  reportType: yup.string().required(REQUIRED_MESSAGE),

  customer_search: yup.string().nullable(),

  // key2: yup.string().required('Este campo es obligatorio'),
});

export default schema;
